import React from 'react';
import { useReviewsTools } from '@app/site/secured/review-manager/provider/useReviewsTools';
import _isEmpty from 'lodash/isEmpty';
import { useCompanyHotels } from '@app/site/secured/rateshopper/rates/provider/useCompanyHotels';
import ReviewScoreTag from '@app/site/secured/review-manager/fragment/reviews-inbox/component/ReviewScoreTag';
import GroupReviewsStateForPeriod from '@app/model/review/state/GroupReviewsStateForPeriod';


const ReviewsGroupPropertyPerformanceHeatmapFragment: React.FunctionComponent<{
	groupReviewsState: GroupReviewsStateForPeriod
}> = ({ groupReviewsState }) => {

	const tools = useReviewsTools();
	const { companyHotels } = useCompanyHotels();


	const findHotelCategoryScore = (hotelId: number, categoryId: number) => {
		const hotelReviewsState = groupReviewsState.findMainHotelStateByHotelId(hotelId);
		if (!hotelReviewsState) return undefined;
		return hotelReviewsState.stateStatisticsForCategories.find(state => state.category.id === categoryId)?.statistics.score;
	};

	return <div className="col-span-4">
		<div className="px-3 mb-1">
			<h2 className="text-base font-semibold text-gray-900">Performance Heatmap</h2>
		</div>
		<div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
			<div className="overflow-x-auto overflow-y-auto">
				<div className="inline-block min-w-full align-middle">
					<table className="min-w-full divide-y divide-gray-300">
						<thead className="bg-gray-50">
						<tr className="divide-x divide-gray-200">
							<th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Category</th>
							{companyHotels.map((ch) => <th
								key={`ch_${ch.id}`}
								scope="col"
								className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 truncate whitespace-nowrap max-w-[150px]">
								{ch.mainHotelName}
							</th>)}

						</tr>
						</thead>
						<tbody className="bg-white divide-y divide-gray-200">
						{tools.categories.filter(rc => !_isEmpty(rc.children)).map((rc) => {

							const scores = companyHotels.map(ch => findHotelCategoryScore(ch.mainHotelId, rc.id));

							return <tr key={`category_${rc.id}`}>
								<td className="whitespace-nowrap px-3 py-3.5 text-sm font-medium text-gray-900 sm:pl-3">
									{rc.name}
								</td>
								{Object.values(scores).map((score, index) => <td
									key={`score_${index}`}
									className="whitespace-nowrap px-3 py-3.5 text-sm font-medium text-gray-900 sm:pl-3">
									<ReviewScoreTag score={score ?? 0} />
								</td>)}
							</tr>;
						})}
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>;
};

export default ReviewsGroupPropertyPerformanceHeatmapFragment;
